// 呼叫符号——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `icon/call/index${i + 1}`,
  name: `icon/callIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/call/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 呼叫符号——主流程，开始
    ...MainRoutes,
  ],
};
